/* eslint-disable no-unused-vars */
export enum ScommesseLeafItem {
  Esito = 'Esito',
  Quota = 'Quota',
  InfoAggiuntiva = 'OnlyInfoAggiuntiva',
  MarcatoriInfoAgg = 'MarcatoriInfoAgg',
  InfoAggiuntivaWithEsito = 'InfoAggiuntiva',
}
/* eslint-emable no-unused-vars */

export type ScommesseLeafItemType = `${ScommesseLeafItem}`;

export interface ScommesseLeafItemProps {
  itemKey: string;
  scommessaKey: string;
  infoAggiuntivaKey: string;
}

export interface LeafProps extends ScommesseLeafItemProps {
  type: ScommesseLeafItemType;
}
